import { FooterYear } from './FooterYear'
import { FlowLogo } from './FlowLogo'

/* Minimal Flow footer — matches Figma node 3310:21925:
   flow logo (left) · social icons + legal (right, legal at 40% opacity). */

const XIcon = () => (
  <svg aria-hidden="true" focusable="false" width="21" height="19" viewBox="0 0 24 21" fill="none">
    <path d="M18.901 0H22.581L14.541 8.892L24 20.5H16.594L10.794 13.338L4.156 20.5H0.474L9.074 11.01L0 0H7.594L12.837 6.526L18.901 0ZM17.61 18.42H19.649L6.486 2.088H4.298L17.61 18.42Z" fill="currentColor"/>
  </svg>
)

const FacebookIcon = () => (
  <svg aria-hidden="true" focusable="false" width="20" height="20" viewBox="0 0 21 21" fill="none">
    <path d="M21 10.5C21 4.70101 16.299 0 10.5 0C4.70101 0 0 4.70101 0 10.5C0 15.7377 3.83908 20.0634 8.85938 20.8542V13.5352H6.19336V10.5H8.85938V8.18555C8.85938 5.55164 10.4233 4.10156 12.8238 4.10156C13.9712 4.10156 15.1719 4.30664 15.1719 4.30664V6.89063H13.8483C12.5499 6.89063 12.1406 7.69266 12.1406 8.51563V10.5H15.0488L14.5816 13.5352H12.1406V20.8542C17.1609 20.0634 21 15.7377 21 10.5Z" fill="currentColor"/>
  </svg>
)

const InstagramIcon = () => (
  <svg aria-hidden="true" focusable="false" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M10 1.802c2.67 0 2.987.01 4.042.058.975.045 1.504.207 1.857.344.467.182.8.399 1.15.748.35.35.566.683.748 1.15.137.353.3.882.344 1.857.048 1.055.058 1.372.058 4.042s-.01 2.987-.058 4.042c-.045.975-.207 1.504-.344 1.857a3.1 3.1 0 0 1-.748 1.15c-.35.35-.683.566-1.15.748-.353.137-.882.3-1.857.344-1.055.048-1.372.058-4.042.058s-2.987-.01-4.042-.058c-.975-.045-1.504-.207-1.857-.344a3.1 3.1 0 0 1-1.15-.748 3.1 3.1 0 0 1-.748-1.15c-.137-.353-.3-.882-.344-1.857C1.812 12.987 1.802 12.67 1.802 10s.01-2.987.058-4.042c.045-.975.207-1.504.344-1.857.182-.467.399-.8.748-1.15.35-.35.683-.566 1.15-.748.353-.137.882-.3 1.857-.344C7.013 1.812 7.33 1.802 10 1.802ZM10 0C7.284 0 6.944.012 5.877.06 4.813.11 4.086.278 3.45.525a4.9 4.9 0 0 0-1.772 1.153A4.9 4.9 0 0 0 .525 3.45C.278 4.086.11 4.813.06 5.877.012 6.944 0 7.284 0 10s.012 3.056.06 4.123c.05 1.064.218 1.791.465 2.427a4.9 4.9 0 0 0 1.153 1.772 4.9 4.9 0 0 0 1.772 1.153c.636.247 1.363.415 2.427.465C6.944 19.988 7.284 20 10 20s3.056-.012 4.123-.06c1.064-.05 1.791-.218 2.427-.465a4.9 4.9 0 0 0 1.772-1.153 4.9 4.9 0 0 0 1.153-1.772c.247-.636.415-1.363.465-2.427.048-1.067.06-1.407.06-4.123s-.012-3.056-.06-4.123c-.05-1.064-.218-1.791-.465-2.427a4.9 4.9 0 0 0-1.153-1.772A4.9 4.9 0 0 0 16.55.525C15.914.278 15.187.11 14.123.06 13.056.012 12.716 0 10 0Zm0 4.865a5.135 5.135 0 1 0 0 10.27 5.135 5.135 0 0 0 0-10.27Zm0 8.468a3.333 3.333 0 1 1 0-6.666 3.333 3.333 0 0 1 0 6.666Zm6.538-8.671a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0Z" fill="currentColor"/>
  </svg>
)

const YouTubeIcon = () => (
  <svg aria-hidden="true" focusable="false" width="24" height="18" viewBox="0 0 29 21" fill="none">
    <path d="M28.4047 3.27831C28.0815 2.04212 27.1135 1.06472 25.8893 0.737824C23.6458 0.141602 14.5604 0.141602 14.5604 0.141602C14.5604 0.141602 5.47497 0.141602 3.23152 0.737824C2.00732 1.06477 1.03929 2.04212 0.716093 3.27831C0.125 5.54047 0.125 10.2607 0.125 10.2607C0.125 10.2607 0.125 14.9808 0.716093 17.243C1.03929 18.4792 2.00732 19.4177 3.23152 19.7446C5.47497 20.3408 14.5604 20.3408 14.5604 20.3408C14.5604 20.3408 23.6458 20.3408 25.8893 19.7446C27.1135 19.4177 28.0815 18.4792 28.4047 17.243C28.9958 14.9808 28.9958 10.2607 28.9958 10.2607C28.9958 10.2607 28.9958 5.54047 28.4047 3.27831ZM11.6197 14.5614V5.95995L19.1316 10.2608L11.6197 14.5614Z" fill="currentColor"/>
  </svg>
)

export function FlowFooter() {
  return (
    <footer className="flow-footer">
      <div className="flow-footer__inner">
        <a href="https://go-flow.ai" className="flow-footer__logo" aria-label="flow by innovaccer">
          <FlowLogo height={40} />
        </a>

        <div className="flow-footer__right">
          <div className="flow-footer__social">
            <a href="https://innovaccer.com" aria-label="X (Twitter)"><XIcon /></a>
            <a href="https://innovaccer.com" aria-label="Facebook"><FacebookIcon /></a>
            <a href="https://innovaccer.com" aria-label="Instagram"><InstagramIcon /></a>
            <a href="https://innovaccer.com" aria-label="YouTube"><YouTubeIcon /></a>
          </div>
          <div className="flow-footer__legal">
            <span>Innovaccer &copy; <FooterYear fallback={new Date().getFullYear()} /></span>
            <a href="https://innovaccer.com/terms-of-use">Terms</a>
            <a href="https://innovaccer.com/privacy">Privacy</a>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default FlowFooter
